import { CustomIcons } from '@ltvco/refresh-lib/theme';
import {
  List,
  Instagram,
  LinkedIn,
  Pinterest,
  Person,
  Phone,
  Home,
  Email,
  AlternateEmail,
  Restore,
  LocalFlorist,
  NotificationsNone,
  Notifications,
  AttachMoney,
  AccountCircle,
  ManageAccounts,
  Summarize,
  Search,
  NotificationsActive,
  FacebookRounded,
  X,
  Radar,
} from '@mui/icons-material';

import { PLLogo } from 'icons';
import imgMigrationCta from 'images/img_migration_cta.svg';

import imgAnimatedPersonMagnifying from './images/ani_person_magnifying.gif';
import downsellModalBackground from './images/circle-gradient-bg.svg';
import imgCurrentOwner from './images/current-owner-icon.svg';
import DigitalIdentityLogo from './images/digital-id-logo.svg';
import downsellSpecialOfferImg from './images/downsellSpecialOffer.svg';
import earthquakeIcon from './images/earthquake.svg';
import imgIdHub from './images/id-hub.svg';
import ComplianceLogo from './images/img-alert.svg';
import imgDarkWebEmail from './images/img-dark-web-email.svg';
import imgFlowerObituary from './images/img-flower-obituary.svg';
import imgSidePromoBanner from './images/img-sidepromo-banner.svg';
import img24hr from './images/img_24hr.svg';
import imgAddressGeneric from './images/img_address_generic_no_bg.svg';
import american_express from './images/img_amex.svg';
import applePay from './images/img_apple_pay.svg';
import imgAttachmentJpg from './images/img_attachment_jpg.svg';
import imgAttachmentPdf from './images/img_attachment_pdf.svg';
import imgGooglePlayBadge from './images/img_badge_google_play.svg';
import imgBell from './images/img_bell.svg';
import imgMonitoringBell from './images/img_bell_monitoring.svg';
import imgCloudDocumentLockBox from './images/img_cloud_document_lockbox.svg';
import imgComputerLimitReached from './images/img_computer_limit_reached.svg';
import imgCustomerService from './images/img_customer_service.svg';
import imgDarkWebScan from './images/img_dark_web_scan.svg';
import discover from './images/img_discover.svg';
import imgEllipsePin from './images/img_ellipse_pin.svg';
import imgExampleAircraft from './images/img_example_aircraft.svg';
import imgExampleAutomobile from './images/img_example_automobile.svg';
import imgExampleWatercraft from './images/img_example_watercraft.svg';
import imgExpiredEmailLink from './images/img_expired_email_link.svg';
import imgFallbackProperty from './images/img_fallback_property.svg';
import imgFraudCheck from './images/img_fraud_check.svg';
import genericCreditCard from './images/img_generic_credit_card.svg';
import googlePay from './images/img_google_pay.svg';
import imgInfinity from './images/img_infinity.svg';
import imgMapDefaultPin from './images/img_map_default_pin.png';
import imgMapMainHomePin from './images/img_map_main_home_pin.svg';
import imgMapPinBlue from './images/img_map_pin_blue.svg';
import imgMapSecondaryPin from './images/img_map_secondary_pin.svg';
import masterCard from './images/img_mastercard.svg';
import imgMonitorBanner from './images/img_neighborhood_safety.svg';
import imgNoticeLeave from './images/img_notice_leave.svg';
import paymentRequired from './images/img_payment_required.svg';
import paymentRequiredV2 from './images/img_payment_required_v2.svg';
import paypal from './images/img_paypal.svg';
import img_pdf_glow from './images/img_pdf_glow.svg';
import imgPersonSearch from './images/img_person_search.svg';
import imgMapBoxPin from './images/img_pin.svg';
import imgReportRating from './images/img_report_rating.svg';
import imgSingleTree from './images/img_single_tree.svg';
import peoplelookerLogo from './images/img_social_beenverified.svg';
import facebookLogo from './images/img_social_facebook.svg';
import instagramLogo from './images/img_social_instagram.svg';
import linkedinLogo from './images/img_social_linkedin.svg';
import pinterestLogo from './images/img_social_pinterest.svg';
import twitterLogo from './images/img_social_twitter.svg';
import imgSingleSignOnCta from './images/img_sso_cta.svg';
import imgSuccessfulUpgrade from './images/img_successful_upgrade.svg';
import imgTreeOfLife from './images/img_tree_of_life.svg';
import imgUploadAttachmentIcon from './images/img_upload_attachment_icon.svg';
import venmo from './images/img_venmo.svg';
import venmoButton from './images/img_venmo_button.svg';
import visa from './images/img_visa.svg';
import Bankrupticies from './images/imgBankruptcies.svg';
import ClaimedReport from './images/imgClaimedReport.svg';
import ClaimReport from './images/imgClaimReport.svg';
import Criminal from './images/imgCriminalTraffic.svg';
import imgDarkWebSection from './images/imgDarkWebSection.svg';
import MonitoringBell from './images/imgMonitoringBell.svg';
import Traffic from './images/imgTraffic.svg';
import landslideIcon from './images/landslide.svg';
import logoSmall from './images/logo-small.svg';
import logo from './images/logo.svg';
import neighborSpoofing from './images/neighbor-spoofing.svg';
import imgNoProperty from './images/no-property-img-fallback.svg';
import imgNotificationBanner from './images/notifications-banner.svg';
import searchIcon from './images/search-icon.svg';
import SearchLogo from './images/search-logo.svg';
import imgSpecializedBackgroundCheck from './images/specialized-background-check.svg';
import imgSpecializedUnclaimedMoney from './images/specialized-unclaimed-money.svg';
import verificationEmail from './images/verification-email.svg';
import wildfireIcon from './images/wildfire.svg';

import type { ReportTypeOption, SideMenuItem } from '@ltvco/refresh-lib/v2';

const baseUrl = `${window.location.protocol}//${window.location.host}`;
const reportTypeFilterOptions: { [key: string]: ReportTypeOption } = {
  detailed_person_report: {
    id: 'detailed_person_report',
    display: 'Person',
    eventLabel: 'Person',
  },
  reverse_phone_report: {
    id: 'reverse_phone_report',
    display: 'Phone',
    eventLabel: 'Phone',
  },
  property_report: {
    id: 'property_report',
    display: 'Property',
    eventLabel: 'Property',
  },
  social_network_report: {
    id: 'social_network_report',
    display: 'Email',
    eventLabel: 'Email',
  },
  username_report: {
    id: 'username_report',
    display: 'Username',
    eventLabel: 'Username',
  },
  unclaimed_money_report: {
    id: 'unclaimed_money_report',
    display: 'Unclaimed Money',
    eventLabel: 'Unclaimed Money',
  },
  phone_fraud_report: {
    id: 'phone_fraud_report',
    display: 'Phone Fraud',
    eventLabel: 'Phone Fraud',
  },
  email_fraud_report: {
    id: 'email_fraud_report',
    display: 'Email Fraud',
    eventLabel: 'Email Fraud',
  },
};

// TODO: should we extend the default config the same way we're doing with the theme? might be good for some props, other props maybe should be required
export const constants = {
  images: {
    imgClaimReport: ClaimReport,
    imgDarkWebSection,
    imgClaimedReport: ClaimedReport,
    brandLogo: logo,
    brandLogoMobile: logoSmall,
    imgAppleStore: '',
    imgGoogleStore: '',
    master: masterCard,
    visa: visa,
    american_express: american_express,
    discover: discover,
    genericCreditCard: genericCreditCard,
    paypal: paypal,
    googlePay: googlePay,
    paymentRequired: paymentRequired,
    paymentRequiredV2: paymentRequiredV2,
    applePay: applePay,
    venmo: venmo,
    venmoButton: venmoButton,
    searchLogo: SearchLogo,
    complianceLogo: ComplianceLogo,
    imgDarkWebEmail: imgDarkWebEmail,
    imgNoProperty,
    imgExampleAircraft: imgExampleAircraft,
    imgExampleWatercraft: imgExampleWatercraft,
    imgExampleAutomobile: imgExampleAutomobile,
    monitoringBell: imgMonitoringBell,
    imgMonitoring: MonitoringBell,
    imgIdHub,
    imgAddressGeneric,
    imgBell,
    imgDarkWebScan,
    imgSpecializedBackgroundCheck,
    imgSpecializedUnclaimedMoney,
    imgReportRating: imgReportRating,
    imgSuccessfulUpgrade: imgSuccessfulUpgrade,
    imgComputerLimitReached: imgComputerLimitReached,
    pdfLogo: img_pdf_glow,
    img24hr,
    neighborSpoofing,
    imgAnimatedPersonMagnifying,
    imgMagnifyingGlassNoResultsPage: '',
    imgMapDefaultPin: imgMapDefaultPin,
    imgMapMainHomePin: imgMapMainHomePin,
    imgMapSecondaryPin: imgMapSecondaryPin,
    imgMonitorBanner: imgMonitorBanner,
    imgMobileExpIcon: '',
    imgCopyIcon: '',
    imgContactlessIcon: '',
    imgUpdatesIcon: '',
    imgEtagsLogo: '',
    imgAddVehicle: '',
    imgNHFacts: '',
    imgMarketTrends: '',
    imgAmenities: '',
    imgWhatIsAVin: '',
    imgWhereIsVin: '',
    imgCustomerService,
    imgExpiredEmailLink,
    imgFallbackProperty,
    imgNoVehicleImageProvided: '',
    imgMapBoxPin,
    imgTreeOfLife,
    imgSingleTree,
    imgInfinity,
    imgPersonSearch,
    imgFlowerObituary,
    imgSingleSignOnCta,
    imgSidePromoBanner,
    imgFraudCheck,
    imgNoticeLeave,
    imgNotificationBanner,
    imgDigitalIdentityLogo: DigitalIdentityLogo,
    downsellModalBackground,
    downsellSpecialOfferImg,
    verificationEmail,
    CourtRecordsImages: {
      imgCriminal: Criminal,
      imgTraffic: Traffic,
      imgBankruptcies: Bankrupticies,
    },
    imgMigrationCta,
    astrology: {
      imgAstrologyNumerology: '',
      imgAstrologyNumerologyV2: '',
      imgAstrologyNumerologyLoading: '',
      compatibilityImg: '',
      aries: '',
      taurus: '',
      gemini: '',
      cancer: '',
      leo: '',
      virgo: '',
      libra: '',
      scorpio: '',
      sagittarius: '',
      capricorn: '',
      aquarius: '',
      pisces: '',
      empty: '',
      emptyBackground: '',
      smallAries: '',
      smallTaurus: '',
      smallGemini: '',
      smallCancer: '',
      smallLeo: '',
      smallVirgo: '',
      smallLibra: '',
      smallScorpio: '',
      smallSagittarius: '',
      smallCapricorn: '',
      smallAquarius: '',
      smallPisces: '',
      smallAscendant: '',
    },
    astrologyStandalone: {
      imgOnboardingBg: '',
      AstrologyIcon: '',
    },
    imgGooglePlayBadge,
    searchIcon,
    imgCurrentOwner,
    earthquakeIcon,
    landslideIcon,
    wildfireIcon,
    imgEllipsePin,
    imgMapPinBlue,
    imgCloudDocumentLockBox,
    imgUploadAttachmentIcon,
    imgAttachmentJpg,
    imgAttachmentPdf,
  },
  links: {
    baseUrl: `${baseUrl}${
      import.meta.env.VITE_PATH_PREFIX?.includes('/')
        ? import.meta.env.VITE_PATH_PREFIX
        : `/${import.meta.env.VITE_PATH_PREFIX}`
    }`,
    joinLink: 'https://www.peoplelooker.com/lp/d8937f/4/select-plan',
    brandLink: import.meta.env.VITE_DEV_PROXY_SEARCH_PERSON_TEASER
      ? ''
      : `${baseUrl}`,
    aboutLink: 'https://peoplelooker.com/about',
    fcraLink: 'https://www.peoplelooker.com/fcra/',
    doDontsLink: 'https://www.peoplelooker.com/uses/',
    tosLink: 'https://www.peoplelooker.com/terms-conditions',
    privacyLink: 'https://www.peoplelooker.com/privacy-policy/',
    contactLink: 'https://www.peoplelooker.com/contact/',
    FaqLink: 'https://www.peoplelooker.com/faq/',
    dontSellInfoLink: 'https://www.peoplelooker.com/svc/optout/search/optouts',
    affiliateLink: 'https://www.peoplelooker.com/affiliates',
    peopleSearchLink: '',
    reversePhoneLink: 'https://www.peoplelooker.com/phone',
    emailLookupLink: '',
    reverseAddressLink: '',
    contactForm: 'https://www.peoplelooker.com/contact/',
    supportLink: 'http://support.peoplelooker.com',
    pinterestLink: 'https://www.pinterest.com/peoplelooker/',
    twitterLink: '',
    facebookLink: 'https://www.facebook.com/peoplelooker/',
    blogLink: 'https://www.peoplelooker.com/blog/',
    rapidsLookupLink: `${baseUrl}/rpds/lookup`,
    mrRogersBaseUrl: '/ss/mrg',
    billingLink: 'https://www.peoplelooker.com/billing/',
    customPlanLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSdBQyTKG39eLvmc5t3wPR4XOQ80nH-xWelCbY8DLGUZ2f35Iw/viewform',
    mapboxStyleUrl: 'mapbox://styles/beenverified/cloywa73e00sd01qnb8162waw',
    dataDeckRootURI: 'hk/dd/v2',
    chatLink: 'https://www.peoplelooker.com/chat/',
    topHapBaseUrl: 'https://widgets.tophap.com/api/widgets',
    cancelSurveyLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSc8g8ZXdWlZtfNPpXRg_EvHeEBGLvEMyhaKmXgIhquRHHZfDg/viewform',
    setupSsoLink: 'https://www.peoplelooker.com/sso_connections',
    brandAndroidUrl:
      'https://play.google.com/store/apps/details?id=com.peoplelooker.android&hl=en_US',
    flagCommentFormLink:
      'https://docs.google.com/forms/d/1PPDNxgUq4pxszCDZLYkcSI2RN4qhetMuG4nMlkk5_-k/edit',
  },
  featureFlags: {
    hasCriminalEnabled: true,
    propertyReportFlags: ['include_ca_data'],
    enableListExport: false,
    hasReportAttachmentsEnabled: true,
  },
  dataCollections: {},
  data: {
    brandName: 'PeopleLooker',
    brandAbbreviation: 'pl' as 'pl',
    brandSupportEmail: 'support@peoplelooker.com',
    legalName: 'PeopleLooker LLC',
    supportPhone: '1-800-592-7153',
    customerSupportPhone: '1-888-579-5910',
    supportEmail: 'support@peoplelooker.com',
    complianceEmail: 'compliance@peoplelooker.com',
    pdfPrice: '$4.95',
    rewardsDisclaimer:
      'Certain products and services, including vehicle purchase/sale opportunities, provided above include offers from third parties and/or external partners from whom we may receive limited compensation. Please be advised that these offers are provided as a convenience and are a sample, but do not necessarily include ALL offers, products or services available in the marketplace.',
    upgradePlanCustomSolutionHeading: 'Need more reports or users?',
    upgradePlanCustomSolutionDescription: 'Let’s talk',
    limitReachedSubHeading:
      'We offer different solutions to match your search needs',
    contactOptionsCustomPlanDisplay: 'Request larger plan',
    unclaimedMoneyDisclaimer:
      'Disclaimer: Unclaimed money search results may not be available for every state.',
    validReportCountThreshold: 5,
    plansWithout5ReportBlocker: [
      'Referral_User_0_1_month_freemium_limit3',
      '7_day_trial_1_00_up_front_28_79_recurring_monthly_freshness_limit_100_vin_no_pdf_vehicle_only',
      '7_day_trial_5_00_up_front_28_79_recurring_monthly_freshness_limit_100_vin_free_pdf_vehicle_only',
    ],
    blockUpgradeWindowThreshold: 24,
    copyrightText:
      '© 2024 PeopleLooker LLC. All rights reserved. PeopleLooker®, and the PEOPLELOOKER eyes logo are registered trademarks of PeopleLooker LLC',
    customerSupportAvailabilityHours: {
      email: 'Available 24 hours a day',
      chat: 'Available 24 hours a day',
    },
  },
  config: {
    socialMedia: [
      {
        textContent: 'X',
        alternateTextContent: '@PeopleLooker',
        href: 'https://www.twitter.com/PeopleLooker',
        imgLogoUrl: twitterLogo,
        icon: <X fontSize="small" sx={{ color: '#24537B' }} />,
        hideOnSide: false,
      },
      {
        textContent: 'Facebook',
        alternateTextContent: 'facebook.com/PeopleLooker',
        href: 'https://www.facebook.com/PeopleLooker',
        imgLogoUrl: facebookLogo,
        icon: <FacebookRounded fontSize="small" sx={{ color: '#24537B' }} />,
        hideOnSide: false,
      },
      {
        textContent: 'Instagram',
        alternateTextContent: 'instagram.com/PeopleLooker',
        href: 'https://www.instagram.com/peoplelooker/',
        imgLogoUrl: instagramLogo,
        icon: <Instagram fontSize="small" sx={{ color: '#24537B' }} />,
        hideOnSide: true,
      },
      {
        textContent: 'Linkedin',
        alternateTextContent: 'linkedin.com/company/peoplelooker',
        href: 'https://www.linkedin.com/company/peoplelooker',
        imgLogoUrl: linkedinLogo,
        icon: <LinkedIn fontSize="small" sx={{ color: '#24537B' }} />,
        hideOnSide: true,
      },
      {
        textContent: 'Pinterest',
        href: 'https://www.pinterest.com/peoplelooker/',
        imgLogoUrl: pinterestLogo,
        icon: <Pinterest fontSize="small" sx={{ color: '#24537B' }} />,
        hideOnSide: true,
      },
      {
        textContent: 'PeopleLooker Blog',
        href: 'https://www.peoplelooker.com/blog/',
        imgLogoUrl: peoplelookerLogo,
        icon: <PLLogo fontSize="medium" sx={{ color: '#24537B' }} />,
        hideOnSide: true,
      },
    ],
    searchTabs: [
      {
        displayName: 'People',
        id: 'peopleTab',
        icon: <Person fontSize="small" sx={{ color: '#24537B' }} />,
        class: 'noBorderBottom noBorderRight',
        internalTabs: [
          {
            label: 'Search By Name',
            mobileLabel: 'Name',
            libFormComponentName: 'SearchPersonForm',
            eventCategory: 'People Search',
          },
          {
            label: 'Search By Address',
            mobileLabel: 'Address',
            libFormComponentName: 'SearchPersonByAddressForm',
            eventCategory: 'Person search by address',
          },
        ],
      },
      {
        displayName: 'Phone',
        id: 'phoneTab',
        icon: <Phone fontSize="small" sx={{ color: '#24537B' }} />,
        class: 'noBorderBottom noBorderRight',
        internalTabs: [
          {
            label: 'Search By Phone Number',
            mobileLabel: 'Phone Number',
            libFormComponentName: 'SearchPhoneForm',
            eventCategory: 'Phone Search',
          },
        ],
      },
      {
        displayName: 'Property',
        id: 'propertyTab',
        icon: <Home fontSize="small" sx={{ color: '#24537B' }} />,
        class: 'noBorderBottom',
        internalTabs: [
          {
            label: 'Address Report',
            mobileLabel: 'Report',
            libFormComponentName: 'SearchPropertyForm',
            eventCategory: 'property',
          },
        ],
      },
      {
        displayName: 'Email',
        id: 'emailTab',
        icon: <Email fontSize="small" sx={{ color: '#24537B' }} />,
        class: 'noBorderRight',
        internalTabs: [
          {
            label: 'Search By Email',
            mobileLabel: 'Email',
            libFormComponentName: 'SearchEmailForm',
            eventCategory: 'Email Search',
          },
        ],
      },
      {
        displayName: 'Username',
        id: 'usernameTab',
        icon: <AlternateEmail fontSize="small" sx={{ color: '#24537B' }} />,
        class: 'noBorderRight',
        internalTabs: [
          {
            label: 'Search By Username',
            mobileLabel: 'Username',
            libFormComponentName: 'SearchUsernameForm',
            eventCategory: 'Username Search',
          },
        ],
      },
    ],
    sideMenuItems: [
      {
        route: '',
        icon: <Summarize sx={{ color: '#24537B', fontSize: '24px' }} />,
        text: 'Reports',
        name: 'reports',
        state: '',
        'data-cy': 'reports',
        childItems: [
          {
            route: '/dashboard/',
            icon: <Restore sx={{ color: '#24537B', fontSize: '24px' }} />,
            text: 'Recent Reports',
            name: 'recentReports',
            state: '',
            'data-cy': 'recent_reports',
          },
          {
            route: '/dashboard/lists',
            icon: <List sx={{ color: '#24537B', fontSize: '24px' }} />,
            text: 'Saved Reports and Lists',
            state: '',
            name: 'lists',
            'data-cy': 'saved_reports_and_list',
          },
        ],
      },
      {
        route: '',
        icon: <Search sx={{ color: '#24537B', fontSize: '24px' }} />,
        text: 'More Searches',
        state: '',
        name: 'more-searches',
        childItems: [
          {
            route: '/dashboard/obituary',
            icon: <LocalFlorist sx={{ color: '#24537B', fontSize: '24px' }} />,
            text: 'Obituary Search',
            state: '',
            name: 'obituarySearch',
          },
          {
            route: '/dashboard/unclaimed-money',
            icon: <AttachMoney sx={{ color: '#24537B', fontSize: '24px' }} />,
            text: 'Unclaimed Money',
            state: '',
            name: 'unclaimedMoney',
            'data-cy': 'unclaimed_money',
          },
          {
            route: '/dashboard/fraud',
            icon: <Radar sx={{ color: '#24537B', fontSize: '24px' }} />,
            text: 'FraudScan',
            state: '',
            name: 'fraudScan',
            'data-cy': 'fraud_scan',
          },
        ],
      },

      {
        route: '',
        icon: (
          <NotificationsActive sx={{ color: '#24537B', fontSize: '24px' }} />
        ),
        text: 'Monitoring Hub',
        state: '',
        name: 'monitoring-hub',
        childItems: [
          {
            route: '/dashboard/monitoring',
            icon: (
              <NotificationsNone sx={{ color: '#24537B', fontSize: '24px' }} />
            ),
            text: 'Monitoring',
            state: '',
            name: 'monitoring',
          },
          {
            route: '/dashboard/dark-web',
            icon: (
              <CustomIcons.DarkWebIcon
                sx={{ color: '#24537B', fontSize: '24px' }}
              />
            ),
            text: 'Dark Web',
            state: '',
            name: 'darkWebScan',
            'data-cy': 'dark_web_scan',
          },
          {
            route: '/dashboard/notifications',
            icon: <Notifications sx={{ color: '#24537B', fontSize: '24px' }} />,
            text: 'Notifications',
            state: '',
            name: 'notifications',
          },
          {
            route: '/dashboard/digital-footprint',
            icon: (
              <CustomIcons.DigitalFootprintIcon
                color="primary"
                sx={{ fontSize: '24px' }}
              />
            ),
            text: 'Digital Footprint',
            state: '',
            name: 'digitalfootprint',
          },
        ],
      },
      {
        route: '/dashboard/billing',
        icon: <AccountCircle sx={{ color: '#24537B', fontSize: '24px' }} />,
        text: 'My Account',
        state: '',
        name: 'myAccount',
        'data-cy': 'my_account',
      },
    ],
    reportTypeFilterOptions,
    higherConfidenceThreshold: 50,
    hardcodedPlans: [],
  },
  keys: {
    rapidsAPIKey: '2skFtN2m6NrKMZnUG8Q4',
    mapboxKey: import.meta.env.VITE_MAPBOX_API_KEY ?? '',
    mrRogersAPIKey: 'TE50RLt3jNZF9VCaRWkvT5UKkybwPU7S',
    streetViewStaticApiKey: 'AIzaSyC4tN7cbPEOaU30DwiK60QHOlx4LqXHO5w',
    topHapApiKey: 'si_MKritZu1BytMaH',
  },
  downsellModalCardData: {
    downsellPlan:
      '9_99_1_month_nofree_afill_peoplelooker_limit20reports_freepdf_downsell',
    downsellPlanAmount: '9.99',
  },
  migrationPlanNames: [
    '22_86_1_month_nofree_afill_limit100reports_freepdf_peoplelooker_plan_migration_v2',
  ],
};

export const monitoringHubTestSideMenuItems: SideMenuItem[] = [
  {
    route: '',
    icon: <Summarize sx={{ color: '#24537B', fontSize: '24px' }} />,
    text: 'Reports',
    name: 'reports',
    state: '',
    'data-cy': 'reports',
    childItems: [
      {
        route: '/dashboard/',
        icon: <Restore sx={{ color: '#24537B', fontSize: '24px' }} />,
        text: 'Recent Reports',
        name: 'recentReports',
        state: '',
        'data-cy': 'recent_reports',
      },
      {
        route: '/dashboard/lists',
        icon: <List sx={{ color: '#24537B', fontSize: '24px' }} />,
        text: 'Saved Reports and Lists',
        state: '',
        name: 'lists',
        'data-cy': 'saved_reports_and_list',
      },
    ],
  },
  {
    route: '',
    icon: <Search sx={{ color: '#24537B', fontSize: '24px' }} />,
    text: 'More Searches',
    state: '',
    name: 'more-searches',
    childItems: [
      {
        route: '/dashboard/obituary',
        icon: <LocalFlorist sx={{ color: '#24537B', fontSize: '24px' }} />,
        text: 'Obituary Search',
        state: '',
        name: 'obituarySearch',
      },
      {
        route: '/dashboard/unclaimed-money',
        icon: <AttachMoney sx={{ color: '#24537B', fontSize: '24px' }} />,
        text: 'Unclaimed Money',
        state: '',
        name: 'unclaimedMoney',
        'data-cy': 'unclaimed_money',
      },
      {
        route: '/dashboard/fraud',
        icon: <Radar sx={{ color: '#24537B', fontSize: '24px' }} />,
        text: 'FraudScan',
        state: '',
        name: 'fraudScan',
        'data-cy': 'fraud_scan',
      },
    ],
  },
  {
    route: '',
    icon: <NotificationsActive sx={{ color: '#24537B', fontSize: '24px' }} />,
    text: 'Monitoring Hub',
    state: '',
    name: 'monitoring-hub',
    childItems: [
      {
        route: '/dashboard/monitoring',
        icon: <NotificationsNone sx={{ color: '#24537B', fontSize: '24px' }} />,
        text: 'Monitoring',
        state: '',
        name: 'monitoring',
      },
      {
        route: '/dashboard/notifications',
        icon: <Notifications sx={{ color: '#24537B', fontSize: '24px' }} />,
        text: 'Notifications',
        state: '',
        name: 'notifications',
      },
      {
        route: '/dashboard/dark-web',
        icon: (
          <CustomIcons.DarkWebIcon
            sx={{ color: '#24537B', fontSize: '24px' }}
          />
        ),
        text: 'Dark Web',
        state: '',
        name: 'darkWebScan',
        'data-cy': 'dark_web_scan',
      },
      {
        route: '/dashboard/digital-footprint',
        icon: (
          <CustomIcons.DigitalFootprintIcon
            color="primary"
            sx={{ fontSize: '24px' }}
          />
        ),
        text: 'Digital Footprint',
        state: '',
        name: 'digitalfootprint',
      },
    ],
  },
  {
    route: '',
    icon: <ManageAccounts sx={{ color: '#24537B', fontSize: '24px' }} />,
    text: 'My Account',
    state: '',
    name: 'my-profile',
    childItems: [
      {
        route: '/dashboard/billing',
        icon: <AccountCircle sx={{ color: '#24537B', fontSize: '24px' }} />,
        text: 'My Profile',
        state: '',
        name: 'myAccount',
        'data-cy': 'my_account',
      },
    ],
  },
];
